//ブラウザがIEか判定を行う
export var isBrowserIe = function () {
    var userAgent = window.navigator.userAgent.toLowerCase();
    //IEの場合は, IE以外の場合はfalseを返却する。
    return userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1;
};
// ブラウザがEdgeか判定を行う
export var isBrouserEdge = function () {
    var userAgent = window.navigator.userAgent.toLowerCase();
    return userAgent.indexOf('edge') !== -1;
};
// iOS版Safariか判定を行う
export var isBrowserIOSSafari = function () {
    var userAgent = window.navigator.userAgent.toLowerCase();
    return userAgent.indexOf('iphone') !== -1 && userAgent.indexOf('safari') !== -1;
};
// ipad版Safariか判定を行う
export var isBrowserIpadSafari = function () {
    var userAgent = window.navigator.userAgent.toLowerCase();
    return ((userAgent.indexOf('ipad') !== -1 && userAgent.indexOf('safari') !== -1) ||
        (userAgent.indexOf('macintosh') !== -1 &&
            'ontouchend' in document &&
            userAgent.indexOf('safari') !== -1));
};
